import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { Category, CreateProduct } from '@thro-types/leihbar';

import { useFormikContext } from 'formik';

interface CategorySelectInterface {
  category: Category;
}

export const CategorySelect = ({ category }: CategorySelectInterface) => {
  const { values, setFieldValue } = useFormikContext<CreateProduct & { categoryIds: number[] }>();

  const handleCategorySelect = (id, checked: boolean) => {
    if (!checked) {
      setFieldValue(
        'categoryIds',
        values.categoryIds.filter(c => id !== c)
      );
    } else {
      setFieldValue('categoryIds', [...values.categoryIds, id]);
    }
  };
  return (
    <Grid item xs={6} md={4} lg={3}>
      <FormControlLabel
        value={category.id}
        label={
          <Typography variant="body1" component="div" sx={{ display: 'inline' }}>
            {category.name}
          </Typography>
        }
        control={
          <Checkbox
            checked={!!values.categoryIds?.find(c => c === category.id)}
            onChange={(e, checked) => {
              handleCategorySelect(category.id, checked);
            }}
          />
        }
      />
    </Grid>
  );
};
